// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".log-form {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.log-form .v-skeleton-loader .v-skeleton-loader__text {\n  height: 40px;\n}\n.log-form .v-skeleton-loader .v-skeleton-loader__text:nth-child(6) {\n  height: 80px;\n}\n.log-form .v-skeleton-loader .v-skeleton-loader__button {\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
